<template>
  <Layout>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <b-row align-h="between" align-v="center">
              <h4 class="card-tittle">Detalle de Flota</h4>
              <div class="justify-content-end">
                <export-button :data="dataExport" fileName="Detalle_Flota" />
                <zip v-if="patents.length > 0" class="spacingButton" :data="documentsByPatents" :patents="true" :title="'Descargar todo'"></zip>
              </div>
            </b-row>
            <filters
                :filtros="filtros"
                :value="filtersValue"
                @change="getAllDetails"
                patentView="getPatentsTAGByRut"
            />
            <b-table
              :items="tableData"
              :fields="fields"
              :current-page="currentPage"
              :busy="isBusy"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              responsive 
              show-empty
              :filter="filtersValue.asignacion"
              :filter-included-fields="'asignacion'"
            >
              <!-- Inicio Spinner en estado "ocupado" de la tabla -->
              <template #table-busy>
                <div class="text-center text-danger my-2">
                  <b-spinner class="align-middle"></b-spinner>
                </div>
              </template>
              <!-- Fin Spinner en estado "ocupado" de la tabla -->

              <template #cell(documentacion)="row">
                <b-button variant="danger" @click="goDocuments(row.item)">
                  Ver
                </b-button>
              </template>

              <template #cell(fechaInicio)="row">
                {{ getDate(row.value) }}
              </template>
              <template #empty="">
                  <h5 style="text-align: center">
                  {{ $t("request.table.empty") }}
                  </h5>
              </template>

              <template #cell(fechaTermino)="row">
                {{ getDate(row.value) }}
              </template>

              <template #cell(revisionTecnica)="row">
                {{ getDate(row.value) }}
              </template>

              <template #cell(tarifa)="row">
                UF {{row.value}}
              </template>

              <template #cell(check)="row">
                <input type="checkbox" @change="chooseAction($event, row.item)" :checked="patents.includes(row.item.patente.replaceAll(' ', ''))">
              </template>

              <template #cell(klmtrosRecorridos)="row">
                {{ getNumberWithSeparators(row.value) }}
              </template>
              <template #cell(gps)="row">
                {{ row.value ? "Si" : "No" }}
              </template>
            </b-table>

            <!-- Inicio Paginación -->
            <div class="col">
              <div
                class="dataTables_paginate paging_simple_numbers float-right"
              >
                <ul class="pagination pagination-rounded mb-0">
                  <!-- pagination -->
                  <b-pagination
                    class="portal"
                    v-model="currentPage"
                    :per-page="perPage"
                    :total-rows="totRegistros"
                  ></b-pagination>
                </ul>
              </div>
            </div>
            <!-- Fin Paginación -->
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from "../../layouts/main";
import ExportButton from "@/components/export-button";
import CreateZipButton from "@/components/create-zip-button";
import tableConfig from "./tableConfig";
import { getDateWithFormat, formatCurrency, thousandSeparator } from "@/utils";
import axios from "@/axios";
import DPConfig from "../../../components/dataPickerConf";
import Filter from "@/components/filters/Filter";
import moment from "moment";

export default {
  data() {
    return {
      sortBy: 'fechaInicio',
      sortDesc: true,
      lang: {
        formatLocale: DPConfig.formatLocale
      },
      documentsByPatents: [],
      tableData: [],
      fields: tableConfig.fields,
      filtros: ['rut', 'contrato', 'asignacion'],
      filtersValue: {
        rutEmpresa: "",
        patent: "",
        period: "",
      },
      currentPage: 1,
      perPage: 10,
      totRegistros: 1,
      isBusy: false,
      patents: [],
      dataExport: []
    };
  },
  components: {
    Layout,
    "export-button": ExportButton,
    "zip": CreateZipButton,
    "filters": Filter
  },
  methods: {
    getDate(date) {
      return getDateWithFormat(date);
    },
    getCurrency(inport) {
      return formatCurrency(inport);
    },
    getNumberWithSeparators(number) {
      return thousandSeparator(number);
    },
    getAllDetails() {
      let fechaDesde = this.filtersValue.period[0] ? moment(this.filtersValue.period[0]).format('YYYY-MM-DD') : moment(new Date("2000-01-01")).format('YYYY-MM-DD');
      let fechaHasta = this.filtersValue.period[1] ? moment(this.filtersValue.period[1]).format('YYYY-MM-DD') : moment(new Date()).format('YYYY-MM-DD');
      let path = `/GetDetalleFlotaLop?RutEmpresa=${this.filtersValue.rutEmpresa}&FechaDesde=${fechaDesde}&FechaHasta=${fechaHasta}&Pagina=${this.currentPage}&Registros=${this.perPage}`;

      if (fechaDesde === "1999-12-31" && fechaHasta === moment(new Date()).format('YYYY-MM-DD')) {
        path = `/GetDetalleFlotaLop?RutEmpresa=${this.filtersValue.rutEmpresa}&Pagina=${this.currentPage}&Registros=${this.perPage}`;
      }
      // Esta validación se hace porque a veces el portal hace dos llamados a la API seteando una fecha.
      // De esta manera la primer llamada nunca tiene fecha y por ende trae el registro completo.

      if (this.filtersValue.numeroContrato) {
        path = path + `&numeroContrato=${this.filtersValue.numeroContrato}`;
      }
      if (this.filtersValue.patent) {
        path = path + `&Patente=${this.filtersValue.patent}`;
      }

      this.isBusy = true;
      axios
        .get(path)
        .then((detalles) => {
          this.tableData = detalles.data.datos;
          this.totRegistros = detalles.data.totalRegistros;
          this.isBusy = false;
          this.getToExport()
        })
        .catch((error) => {
          if (error.response) {
            this.$bvToast.toast(
              this.$t("lease.request.error.message").toString(),
              {
                title: this.$t("lease.request.error.nonFound").toString(),
                variant: "danger",
                solid: true,
              }
            );
          }
          this.isBusy = false;
        });
    },
    getToExport() {
      let path = `/GetDetalleFlotaLop?RutEmpresa=${this.filtersValue.rutEmpresa}&Pagina=1&Registros=${this.totRegistros}`;
      if (this.filtersValue.numeroContrato) {
        path = path + `&numeroContrato=${this.filtersValue.numeroContrato}`;
      }
      if (this.filtersValue.patent) {
        path = path + `&Patente=${this.filtersValue.patent}`;
      }
      axios
        .get(path)
          .then((detalles) => {
            this.dataExport = detalles.data.datos;
          })
    },
    goDocuments(detalle) {
      this.$store.dispatch("hideValue/updatePatente", detalle.patente.replaceAll(' ', ''));
      this.$router.push({ path: "documentos" });
    },
    chooseAction(event, floatDetail) {
      if (event.target.checked) {
        if (this.addPatent(floatDetail)) {
          event.target.checked = false;
          this.$bvToast.toast(this.$t('floatDetail.toast.message').toString(), {
            title: this.$t('floatDetail.toast.title').toString(),
            variant: 'danger',
            solid: true
          });
        }
      }
      else {
        this.removePatent(floatDetail);
      }
    },
    addPatent(floatDetail) {
      const patent = floatDetail.patente.replaceAll(' ', '');
      if (!this.patents.includes(patent)) {
        this.patents.push(patent);
        axios.get(`/GetDocumentacionVehiculoByPatente/${patent}`)
            .then((response) => {
              this.documentsByPatents.push({
                patent,
                documentation: response.data
              });
            })
        .catch((error) => console.log(error))
        return false;
      }
      else {
        return true;
      }
    },
    removePatent(floatDetail) {
      const index = this.patents.findIndex(patent => patent === floatDetail.patente.replaceAll(' ', ''))
      if (index >= 0) {
        this.patents.splice(index, 1);
        this.documentsByPatents.splice(index, 1);
      }
    }
  },
  watch: {
    currentPage() {
      this.getAllDetails();
    },
  },
};
</script>

<style>
.spacingButton{
  margin-left: 1rem;
}
</style>